<template>
  <div class="home">
    <FreeSequHealth></FreeSequHealth>
    <TrustEconomy></TrustEconomy>
    <Products></Products>
    <DownloadBrochure></DownloadBrochure>
  </div>
</template>

<script>
// @ is an alias to /src
import FreeSequHealth from "../components/FreeSequHealth";
import TrustEconomy from "../views/TrustEconomy";
import Products from "../components/Products";
import DownloadBrochure from "../components/DownloadBrochure";

export default {
  name: 'Home',
  components: {
      DownloadBrochure,
      Products,
      TrustEconomy,
      FreeSequHealth
  }
}
</script>
